// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".red[data-v-1d8db6cc] {\n  color: #ed4014;\n}", ""]);
// Exports
module.exports = exports;
